import React, { useEffect, useState } from "react";
import tw from "tailwind-styled-components";
import RentDetails from "./RentDetails";
import PersonalDetails from "./PersonalDetails";
import GuardianDetails from "./GuardianDetails";
import OccupationDetails from "./OccupationDetails";
import { useSelector } from "react-redux";

export default function TenantInfo({
  data,
  error,
  isLoading,
  setSelectedData,
  selectedData,
  isRefetching,
  editRentDetailMutate,
  editPersonalDetailMutate,
  addGuardianDetailMutate,
  editOccupationDetailMutate,
  isRentDetailLoading,
  isPersonalDetailLoading,
  isGuardianDetailLoading,
  isOccupationDetailLoading,
  e
}
) {
  const user = useSelector((state) => state.UserReducer.user);

  return (
    <>
      <Wrapper>
        {/* Rent Details Section */}
        <>
          <RentDetails
            tenantData={data}
            editRentDetailMutate={editRentDetailMutate}
            isRentDetailLoading={isRentDetailLoading}
            setSelectedData={setSelectedData}
            selectedData={selectedData}
            e={e}
          />
        </>

        {/* Personal Details Section */}
        <>
          <PersonalDetails
            tenantData={data}
            editPersonalDetailMutate={editPersonalDetailMutate}
            isPersonalDetailLoading={isPersonalDetailLoading}
            setSelectedData={setSelectedData}
            selectedData={selectedData}
            e={e}
          />
        </>

        {/* Guardian Details Section */}
        <>
          <GuardianDetails
            tenantData={data?.tenantGuardian}
            //tenantData={data}
            addGuardianDetailMutate={addGuardianDetailMutate}
            isGuardianDetailLoading={isGuardianDetailLoading}
            setSelectedData={setSelectedData}
            selectedData={selectedData}
            e={e}
          />
        </>

        {/* Occupation Details Section */}
        <>
          <OccupationDetails
            tenantData={data}
            editOccupationDetailMutate={editOccupationDetailMutate}
            isOccupationDetailLoading={isOccupationDetailLoading}
            setSelectedData={setSelectedData}
            selectedData={selectedData}
            e={e}
          />
        </>
      </Wrapper>
    </>
  );
}

const Wrapper = tw.div` space-y-4 mt-2`;
